'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.Restrictor = /*#__PURE__*/function () {
  function Restrictor(controller) {
    (0, _classCallCheck2["default"])(this, Restrictor);
    this._controller = controller;
    this.startEvent = new Entry.Event(this);
    this.endEvent = new Entry.Event(this);
    Entry.Curtain.init(controller && controller.isRestrictorCloseable);
    this.currentTooltip = null;
  }
  return (0, _createClass2["default"])(Restrictor, [{
    key: "restrict",
    value: function restrict(data, toolTipRender) {
      this._data = data;
      Entry.expectedAction = data.content.concat();
      this.toolTipRender = toolTipRender;
      this.end();
      var log = data.content.concat();
      var commandType = log.shift();
      var command = Entry.Command[commandType];
      var domQuery = command.dom;
      this.startEvent.notify();
      if (domQuery instanceof Array) {
        domQuery = this.processDomQuery(domQuery);
      }
      if (!data.tooltip) {
        data.tooltip = {
          title: '액션',
          content: '지시 사항을 따르시오'
        };
      }
      if (command.restrict) {
        this.currentTooltip = command.restrict(data, domQuery, this.restrictEnd.bind(this), this);
        return;
      } else {
        this.currentTooltip = new Entry.Tooltip([{
          title: data.tooltip.title,
          content: data.tooltip.content,
          target: domQuery
        }], {
          restrict: true,
          dimmed: true,
          callBack: this.restrictEnd.bind(this)
        });
        window.setTimeout(this.align.bind(this));
      }
      if (data.skip) {
        return this.end();
      }
    }
  }, {
    key: "end",
    value: function end() {
      if (this.currentTooltip) {
        this.currentTooltip.dispose();
        this.currentTooltip = null;
      }
    }
  }, {
    key: "restrictEnd",
    value: function restrictEnd() {
      this.endEvent.notify();
    }
  }, {
    key: "align",
    value: function align() {
      if (this.currentTooltip) {
        this.currentTooltip.alignTooltips();
      }
    }
  }, {
    key: "processDomQuery",
    value: function processDomQuery(domQuery, log) {
      log = log || this._data.content;
      log = log.concat();
      log.shift();
      if (domQuery instanceof Array) {
        domQuery = domQuery.map(function (q) {
          if (q[0] === '&') {
            return log[Number(q.substr(1))][1];
          } else {
            return q;
          }
        });
      }
      return domQuery;
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      if (this.currentTooltip) {
        this.currentTooltip.render();
      }
    }
  }, {
    key: "fadeOutTooltip",
    value: function fadeOutTooltip() {
      if (this.currentTooltip) {
        this.currentTooltip.fadeOut();
      }
    }
  }, {
    key: "fadeInTooltip",
    value: function fadeInTooltip() {
      if (this.currentTooltip) {
        this.currentTooltip.fadeIn();
      }
    }
  }, {
    key: "isTooltipFaded",
    value: function isTooltipFaded() {
      if (this.currentTooltip) {
        return this.currentTooltip.isFaded();
      }
      return false;
    }
  }, {
    key: "requestNextData",
    value: function requestNextData() {
      if (this._controller) {
        return this._controller.requestNextData();
      }
    }
  }]);
}();